/**
 * composerLimits — the file-count cap, on a leaf the public pages can import.
 *
 * WHY A THIRD COPY EXISTS, deliberately. The cap is defined in
 * `src/services/prest0nSession/client.ts`, beside the byte limit that does the
 * real work, and that comment is right that "three copies of a magic number is
 * how they drift apart". But the home page states the cap as a concrete fact,
 * and importing it from `client.ts` pulls in `firebase/auth` — an auth module
 * graph for one integer, on the first-paint path, and unimportable in a plain
 * test environment (it needs `fetch` at module scope).
 *
 * So this is the same arrangement `src/config/trialTerms.ts` uses: a pure,
 * import-free constants leaf whose agreement with its source is a CI gate
 * rather than a hope. `scripts/check-frontend-constant-mirrors.mjs` pins all
 * three — the server's `MAX_FILES_PER_REQUEST`, the composer's
 * `MAX_ATTACHMENTS_PER_MESSAGE`, and this — so a change to any one of them
 * fails the build until the others follow.
 *
 * KEEP THIS FILE IMPORT-FREE. It is on the first-paint path of `/`, and the
 * gate asserts it.
 */

/**
 * Files a single request may carry. The published figure on the home page and
 * in the signed-out Prest0n's page grounding.
 *
 * Mirrors:
 *   functions/src/prest0nSession/gcsSignedUrls.ts  MAX_FILES_PER_REQUEST
 *   src/services/prest0nSession/client.ts          MAX_ATTACHMENTS_PER_MESSAGE
 */
export const MAX_FILES_PER_REQUEST_UI = 50;
